/**
 * @format
 * @flow strict-local
 */
// INIT

const initialState = {
	accessRefreshToken: "",
	accessToken: "",
	profile: {},
	subscription: {}
};

// EXPORT

export default (state = initialState, action) => {
	switch(action.type) {
		case "RESET_ALL":
		return initialState;
		case "SET_USER_ACCESS_REFRESH_TOKEN":
		return {
			...state,
			accessRefreshToken: action.payload
		};
		case "SET_USER_ACCESS_TOKEN":
		return {
			...state,
			accessToken: action.payload
		};
		case "SET_USER_PROFILE":
		return {
			...state,
			profile: action.payload
		};
		case "SET_USER_SUBSCRIPTION":
		return {
			...state,
			subscription: {
				...state.subscription,
				...action.payload
			}
		};
		default:
		return state;
	}
};
